// This is the javascript entrypoint for the featured-collection section.
// This file and all its inclusions will be processed through postcss

class ShowdownTabs extends HTMLElement {
    constructor() {
      super();
  
      this.buttons = this.querySelectorAll('.showdown-tabs-button');
      this.tabs = this.querySelectorAll('.showdown-content');
  
      Array.from(this.buttons).forEach(function(btn){
        btn.addEventListener('click', this.switchTab.bind(this));
      }, this);
    }
  
    switchTab (e) {
      e.preventDefault();
      let tab_index = e.target.closest('a').dataset.index;
      Array.from(this.buttons).forEach(function(btn){
        if(btn.dataset.index != tab_index) {
          btn.classList.remove('active');
        }else {
          btn.classList.add('active');
        }
      }, this);
      Array.from(this.tabs).forEach(function(tab){
        if(tab.dataset.index != tab_index) {
          tab.classList.remove('active');
        }else {
          tab.classList.add('active');
        }
      }, this);
    }
}
  
customElements.define('showdown-tabs', ShowdownTabs);